import { useState } from 'react';

import { useMediaQuery, Grid, Typography, TextField, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';
import useRDStation from '@/src/lib/rdstation/useRDStation';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(3, 2),
    borderRadius: theme.spacing(2),
    background: theme.palette.alternate.dark,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  cover: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    marginBottom: theme.spacing(3),
  },
  form: {
    '& .MuiTextField-root': {
      background: theme.palette.background.paper,
    },
    '& .MuiOutlinedInput-input': {
      background: theme.palette.background.paper,
    },
  },
  inputTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
}));

function SidebarNewsletter({ ...rest }) {
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const { message, error, loading, subscribe } = useRDStation();

  const handleSubscribe = () => {
    subscribe({
      email,
      name,
      conversionIdentifier: 'newsletter',
      campaign: 'blog',
      onSuccess: () => {
        setEmail('');
        setName('');
      },
    });
  };

  return (
    <div className={classes.root} {...rest}>
      <div className={classes.cover}>
        <Image
          src="/images/illustrations/newsletters/newsletter-3.svg"
          alt="Ilustração com pessoa enviando mensagem"
          width="100%"
        />
      </div>
      <SectionHeader
        title="Newsletter"
        subtitle="Increva-se para receber nossos artigos e novidades antes de todo mundo."
        titleProps={{
          variant: 'h4',
          color: 'textPrimary',
        }}
        subtitleProps={{
          variant: 'body1',
          color: 'textPrimary',
        }}
        align="left"
      />
      <div className={classes.form}>
        <Grid container spacing={isMd ? 4 : 2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" color="textPrimary" className={classes.inputTitle}>
              Nome completo
            </Typography>
            <TextField
              placeholder="Seu nome completo"
              variant="outlined"
              size="medium"
              name="fullname"
              fullWidth
              type="text"
              error={error}
              disabled={loading}
              onChange={evt => setName(evt.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" color="textPrimary" className={classes.inputTitle}>
              E-mail
            </Typography>
            <TextField
              placeholder="Seu e-mail"
              variant="outlined"
              size="medium"
              name="email"
              fullWidth
              type="email"
              error={error}
              disabled={loading}
              onChange={evt => setEmail(evt.target.value)}
              onKeyPress={evt => {
                if (evt.key === 'Enter') {
                  handleSubscribe();
                  evt.preventDefault();
                }
              }}
            />
          </Grid>
          <Grid item container justifyContent="center" xs={12}>
            <Button
              aria-label="Inscrever-se"
              variant="contained"
              type="submit"
              color="primary"
              size="large"
              onClick={handleSubscribe}>
              Inscrever-se
            </Button>
          </Grid>
          {message && (
            <Grid>
              <Typography variant="body2">{message}</Typography>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
}

SidebarNewsletter.propTypes = {};

export default SidebarNewsletter;
